import Link from 'next/link';
import { GradientText } from '@/components/ui/gradient-text';
import Image from 'next/image';

export function Logo() {
  return (
    <Link href="/" className="flex items-center gap-2" prefetch={false}>
      {/* Mobile: Logo only */}
      <div className="block sm:hidden">
        <Image 
          src="/Keera_Logo.png" 
          alt="KeeRa Innovations Logo" 
          width={44} 
          height={44}
          className="h-11 w-11 object-contain"
        />
      </div>
      
      {/* Desktop: Logo + Text */}
      <div className="hidden sm:flex items-center gap-2">
         <Image 
            src="/Keera_Logo.png" 
            alt="KeeRa Innovations Logo" 
            width={44} 
            height={44}
            className="h-11 w-auto object-contain"
          />
         <div className="flex flex-col">
            <GradientText as="span" className="font-headline text-xl font-bold leading-tight">KeeRa</GradientText>
            <GradientText as="span" className="font-headline text-xl font-bold leading-tight -mt-1">Innovations</GradientText>
         </div>
      </div>
    </Link>
  );
}
